import React from 'react';
import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

interface CardProps extends React.HTMLAttributes<HTMLDivElement> {}

const Card: React.FC<CardProps> = ({ className, ...props }) => {
  return (
    <div
      className={cn(
        'rounded-[1.35rem] border border-[var(--admin-border)] bg-[var(--admin-surface)] text-[var(--admin-text)] shadow-[var(--admin-shadow)]',
        className
      )}
      {...props}
    />
  );
};

export const CardHeader: React.FC<CardProps> = ({ className, ...props }) => (
  <div className={cn('flex flex-col space-y-1.5 p-5 md:p-6', className)} {...props} />
);

export const CardTitle: React.FC<CardProps> = ({ className, children, ...props }) => (
  <h3 className={cn('font-semibold leading-none tracking-tight text-[var(--admin-text)]', className)} {...props}>
    {children ?? <span className="sr-only">Card title</span>}
  </h3>
);

export const CardContent: React.FC<CardProps> = ({ className, ...props }) => (
  <div className={cn('p-5 pt-0 md:p-6 md:pt-0', className)} {...props} />
);

export default Card;
